import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme, COLOR_THEMES } from '../../contexts/ThemeContext';
import styles from './Settings.module.css';

const Settings = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme, isDark, colorTheme, setColorTheme } = useTheme();

  return (
    <div className={styles.settings}>
      {/* 顶部导航 */}
      <div className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h1 className={styles.title}>应用设置</h1>
      </div>

      <div className={styles.content}>
        {/* 主题色 */}
        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>主题色</h3>
          <p className={styles.sectionDesc}>选择你喜欢的主题色</p>
          <div className={styles.colorGrid}>
            {Object.entries(COLOR_THEMES).map(([key, value]) => {
              const [r, g, b] = value.main.split(' ').map(Number);
              const isActive = colorTheme === key;
              return (
                <button
                  key={key}
                  type="button"
                  className={`${styles.colorOption} ${isActive ? styles.colorOptionActive : ''}`}
                  onClick={() => setColorTheme(key)}
                  title={value.name}
                >
                  <span
                    className={styles.colorSwatch}
                    style={{ background: `rgb(${r}, ${g}, ${b})` }}
                  />
                  <span className={styles.colorName}>{value.name}</span>
                  {isActive && (
                    <span className={`material-icons-round ${styles.checkIcon}`}>check</span>
                  )}
                </button>
              );
            })}
          </div>
        </section>

        {/* 深色模式 */}
        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>显示模式</h3>
          <div className={styles.modeRow}>
            <div className={styles.modeInfo}>
              <span className={`material-symbols-outlined ${styles.modeIcon}`}>
                {isDark ? 'dark_mode' : 'light_mode'}
              </span>
              <div>
                <div className={styles.modeLabel}>
                  {isDark ? '深色模式' : '浅色模式'}
                </div>
                <div className={styles.modeDesc}>
                  {isDark ? '降低屏幕亮度，保护视力' : '明亮清爽的显示风格'}
                </div>
              </div>
            </div>
            <label className={styles.toggleSwitch}>
              <input
                type="checkbox"
                checked={isDark}
                onChange={toggleTheme}
              />
              <span className={styles.toggleSlider} />
            </label>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Settings;

